import { usePage } from '@inertiajs/react'
import BackToSchoolBanner from '@/Components/BackToSchoolBanner'
import HouseOfPradaLensCreditsBanner from '@/Components/HouseOfPradaLensCreditsBanner'

export default ({ blok }) => {
    const { component, props } = usePage()
    const promotions = props.settings?.promotions

    // While both run, the House of Prada lens credit event fronts the home page;
    // Back to School takes the strip back the moment it ends.
    if (component === 'Home' && promotions?.lensCreditEvent?.active) {
        return <HouseOfPradaLensCreditsBanner href="/newest/luxury-lens-credits" />
    }

    if (component === 'Home' && promotions?.backToSchool?.active) {
        return <BackToSchoolBanner />
    }

    const href = blok.link?.url || blok.link?.cached_url || '/glasses'

    return (
        <a href={href} className={blok.class}>
            {blok.title}
        </a>
    )
}
